import { render } from "./TestDataViewQuestions.vue?vue&type=template&id=95d2e92e"
import script from "./TestDataViewQuestions.vue?vue&type=script&lang=js"
export * from "./TestDataViewQuestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__